"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _formGroup = _interopRequireDefault(require("../formGroup/formGroup"));

var _link = _interopRequireDefault(require("../link/link"));

var _lodash = _interopRequireDefault(require("lodash"));

var _tableModule = _interopRequireDefault(require("./table.module.css"));

var _themeModule = _interopRequireDefault(require("../../../styles/theme.module.css"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _table = _interopRequireDefault(require("./table"));

var _button = _interopRequireDefault(require("../button/button"));

var _heading = _interopRequireDefault(require("../heading/heading"));

var _loader = _interopRequireDefault(require("../loader/loader"));

var _hrefLink = _interopRequireDefault(require("../hrefLink/hrefLink"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var TableAccordion = function TableAccordion(props) {
  var id = props.id,
      data = props.data,
      expanded = props.expanded,
      columns = props.columns,
      onExpand = props.onExpand,
      selectable = props.selectable,
      selected = props.selected,
      onDatumSelect = props.onDatumSelect,
      accordionItemHeaderFormatter = props.accordionItemHeaderFormatter,
      hasActions = props.hasActions,
      actions = props.actions,
      renderAsList = props.renderAsList,
      onTableRowExpand = props.onTableRowExpand,
      expandedTableRows = props.expandedTableRows,
      expandableRow = props.expandableRow,
      customNestedTableComponent = props.customNestedTableComponent,
      loadingRows = props.loadingRows,
      noResultsMessage = props.noResultsMessage,
      selectableRowDisabled = props.selectableRowDisabled;
  var CustomNestedTableComponent = customNestedTableComponent;

  var ActionsCell = function ActionsCell(_ref) {
    var actions = _ref.actions,
        datum = _ref.datum,
        rowIndex = _ref.rowIndex;
    return _react.default.createElement("div", {
      id: rowIndex ? rowIndex : null
    }, actions.map(function (action, index) {
      if (action.customComponent) {
        var Comp = action.customComponent;
        return _react.default.createElement(Comp, {
          id: rowIndex ? "".concat(rowIndex, "_custom_action") : null,
          key: index,
          datum: datum,
          action: action,
          rowIndex: rowIndex
        });
      } else if (action.isActionLink) {
        var to = action.callback(datum, rowIndex);
        return _react.default.createElement("div", {
          id: id ? "".concat(id, "_table_item_").concat(index, "_link_wrapper") : null,
          key: index
        }, _react.default.createElement(_hrefLink.default, {
          id: id ? "".concat(id, "_table_item_").concat(index, "_link_wrapper") : null,
          key: index,
          to: to,
          arrowDirection: action.arrowDirection,
          reversedArrow: action.reversedArrow
        }));
      }

      return _react.default.createElement("div", {
        id: id ? "".concat(id, "_table_item_").concat(index, "_link_wrapper") : null,
        key: index
      }, _react.default.createElement(_link.default, {
        id: id ? "".concat(id, "_table_item_").concat(index, "_link") : null,
        disabled: action.isDisabled ? action.isDisabled(datum) : false,
        onClick: function onClick() {
          return action.callback(datum, rowIndex);
        },
        arrowDirection: "left",
        variant: "tertiary",
        label: action.label
      }));
    }));
  };

  return _react.default.createElement("div", {
    id: id ? id : null,
    className: (0, _classnames.default)(_themeModule.default.arag, _tableModule.default["panel-group"]),
    role: "tablist",
    "aria-multiselectable": true
  }, data && data.length === 0 && noResultsMessage ? _react.default.createElement("div", {
    className: _tableModule.default["no-result-message"]
  }, noResultsMessage) : data.map(function (datum, index) {
    return _react.default.createElement("div", {
      id: id ? "".concat(id, "_table_datum_").concat(index + 1) : null,
      className: (0, _classnames.default)(_tableModule.default.panel, _tableModule.default["panel-default"]),
      key: index
    }, _react.default.createElement("div", {
      id: id ? "".concat(id, "_table_datum_").concat(index + 1, "_heading_wrapper") : null,
      className: _tableModule.default["panel-heading"],
      role: "tab",
      onClick: function onClick() {
        return onExpand(index);
      }
    }, _react.default.createElement("h4", {
      id: id ? "".concat(id, "_table_datum_").concat(index + 1, "_heading") : null,
      className: _tableModule.default["panel-title"]
    }, _react.default.createElement("span", {
      id: id ? "".concat(id, "_table_datum_").concat(index + 1, "_heading_button") : null,
      role: "button",
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "aria-expanded": "false",
      "aria-controls": "collapseOne",
      className: "collapsed"
    }, accordionItemHeaderFormatter ? accordionItemHeaderFormatter(datum) : "Item #".concat(index + 1)))), expanded.includes(index) && _react.default.createElement("div", {
      id: id ? "".concat(id, "_table_datum_").concat(index + 1, "_expanded") : null,
      className: (0, _classnames.default)(_tableModule.default["panel-collapse"], _tableModule.default["collapse"], _tableModule.default["in"]),
      role: "tabpanel",
      "aria-labelledby": "headingOne",
      "aria-expanded": "false"
    }, _react.default.createElement("div", {
      id: id ? "".concat(id, "_table_datum_").concat(index + 1, "_expanded_custom_element_wrapper") : null,
      className: _tableModule.default["panel-body"]
    }, renderAsList && _react.default.createElement("div", {
      id: id ? "".concat(id, "_table_datum_").concat(index + 1, "_expanded_custom_element") : null
    }, datum.element), !renderAsList && _react.default.createElement(_react.default.Fragment, null, loadingRows && loadingRows.length && loadingRows.includes(index) ? _react.default.createElement(_loader.default, {
      id: id ? "".concat(id, "_table_datum_").concat(index + 1, "_loader") : null,
      variant: "list"
    }) : _react.default.createElement("form", {
      id: id ? "".concat(id, "_table_datum_").concat(index + 1, "_form") : null,
      className: "form-horizontal"
    }, _react.default.createElement("fieldset", {
      id: id ? "".concat(id, "_table_datum_").concat(index + 1, "_fieldset") : null
    }, columns.filter(function (x) {
      return x.hidden !== true;
    }).map(function (column) {
      return _react.default.createElement(_formGroup.default, {
        id: id ? "".concat(id, "_table_datum_").concat(index + 1, "_input") : null,
        key: column.header,
        labelSize: "col-sm-3",
        inputSize: "col-sm-7",
        label: column.header,
        variant: "plain",
        inputProps: {
          label: column.formatter ? column.formatter(datum) : _lodash.default.get(datum, column.propertyName)
        }
      });
    }), selectable && _react.default.createElement(_formGroup.default, {
      id: id ? "".concat(id, "_table_datum_").concat(index + 1, "_selectable_input") : null,
      labelSize: "col-sm-3",
      inputSize: "col-sm-7",
      variant: "checkbox",
      inputProps: {
        disabled: selectableRowDisabled && selectableRowDisabled(datum),
        name: "checkbox_".concat(index),
        checked: !!selected[index],
        onChange: function onChange(evt) {
          return onDatumSelect(evt.target.checked, index, datum);
        }
      }
    }), hasActions && _react.default.createElement(ActionsCell, {
      actions: actions,
      datum: datum,
      rowIndex: index
    }), expandableRow && expandedTableRows && _react.default.createElement("div", {
      id: id ? "".concat(id, "_table_datum_").concat(index + 1, "_expandable_button_wrapper") : null,
      className: _tableModule.default["form-group"]
    }, _react.default.createElement(_button.default, {
      id: id ? "".concat(id, "_table_datum_").concat(index + 1, "_expandable_button") : null,
      variant: expandedTableRows.includes(index) ? "close" : "open",
      onClick: function onClick() {
        return onTableRowExpand(index, datum);
      }
    })), expandableRow && expandedTableRows.includes(index) && _react.default.createElement("div", {
      id: id ? "".concat(id, "_table_datum_").concat(index + 1, "_expandable_header_wrapper") : null,
      className: _tableModule.default["form-group"]
    }, _react.default.createElement(_heading.default, {
      id: id ? "".concat(id, "_table_datum_").concat(index + 1, "_expandable_header") : null,
      variant: "h3",
      title: expandableRow.nestedTableTitle
    }), CustomNestedTableComponent ? _react.default.createElement(CustomNestedTableComponent, {
      columns: expandableRow.columns,
      data: _lodash.default.get(datum, expandableRow.propertyNameWithData),
      previousRow: datum,
      previousRowIndex: index
    }) : _react.default.createElement(_table.default, _extends({
      id: id ? id : null,
      accordionItemHeaderFormatter: expandableRow.accordionItemHeaderFormatter,
      striped: true,
      tableHover: true,
      nestedTableTitle: expandableRow.nestedTableTitle,
      data: expandableRow.dataFormatter ? expandableRow.dataFormatter(_lodash.default.get(datum, expandableRow.propertyNameWithData)) : _lodash.default.get(datum, expandableRow.propertyNameWithData),
      columns: expandableRow.columns
    }, expandableRow.nestedTableProps)))))))));
  }));
};

TableAccordion.propTypes = {
  /** String text that specifies a unique id for an HTML element. Consistent Id type: snake_case*/
  id: _propTypes.default.string,

  /** Array that contains the rows indexes that should have a loader */
  loadingRows: _propTypes.default.arrayOf(_propTypes.default.number),

  /** The data that should be displayed. Can by an array of objects of any type and shape */
  data: _propTypes.default.arrayOf(_propTypes.default.object).isRequired,

  /** The columns of the list - table. The propertyName is used to match the desired property of the data objects.
   * eg: the data object {email : "user@test.io"} will be matched by the column: {propertyName: "email", header:
   * "Email!"}. If you wish to access nested properties from the data you should specify them again in the
   * propertyName separated with a dot "." eg: data: {user: {email : "user@test.io"}}, then the property name will be
   * propertyName: "user.email". The id property of is used for sorting. So it must match the correct sortBy key.
   * The formatter is a callback used to format the data as you wish. It is invoked with the datum. For example
   * formatting timestamp dates. the sortable prop specifies if the column is sortable. Property is required if not
   * rendered as a list*/
  columns: _propTypes.default.arrayOf(_propTypes.default.shape({
    propertyName: _propTypes.default.string.isRequired,
    header: _propTypes.default.string.isRequired,
    id: _propTypes.default.string,
    formatter: _propTypes.default.func,
    sortable: _propTypes.default.bool,
    hidden: _propTypes.default.bool
  })),

  /** Array that contains the indexes of the expanded rows - panel items*/
  expanded: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])),

  /** Callback invoked with the index of the item that should be expanded passed as an argument*/
  onExpand: _propTypes.default.func.isRequired,

  /** Callback invoked with the entire row - datum in order to format the accordion item header as you wish!*/
  accordionItemHeaderFormatter: _propTypes.default.func,

  /** Boolean indicating that the items are selectable. If set to true, the props selected, onDatumSelect
   *  MUST be specified */
  selectable: _propTypes.default.bool,

  /** Renders the component as an accordion list. If this is the case then the data array must contain the list items */
  renderAsList: _propTypes.default.bool,

  /** Object containing the selected items */
  selected: _propTypes.default.object,

  /** Callback invoked  when the use checks a row - item. It will be passed with the arguments: checked(bool),
   * index(number), datum(object), eg: (checked, index, datum) => {}*/
  onDatumSelect: _propTypes.default.func,

  /** Boolean prop that when is set to true an extra column will be displayed to display the actions - links.
   * If set to true the property actions must be specified */
  hasActions: _propTypes.default.bool,

  /** Array of the desired actions. The callback will be invoked when the corresponding action is clicked.
   * The callback function with have the row datum and row index passed as arguments. */
  actions: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string.isRequired,
    callback: _propTypes.default.func.isRequired,
    customComponent: _propTypes.default.element,
    isActionLink: _propTypes.default.bool
  })),

  /** object that describes the expandable row table. You can also add all the properties of The Table component
   * in the property nestedTableProps and they will be passed to the nested component. If you want to map-alter the
   * data before display use the dataFormatter function property. It will be called with the data for display. It
   * MUST return the altered data.*/
  expandableRow: _propTypes.default.shape({
    columns: _propTypes.default.arrayOf(_propTypes.default.shape({
      propertyName: _propTypes.default.string.isRequired,
      header: _propTypes.default.string.isRequired,
      formatter: _propTypes.default.func
    })),
    propertyNameWithData: _propTypes.default.string.isRequired,
    dataFormatter: _propTypes.default.func,
    nestedTableProps: _propTypes.default.object
  }),

  /** Custom component to replace the built in nested Table component of each row. It will have the
   * expandable table row passed as a prop */
  customNestedTableComponent: _propTypes.default.element,
  noResultsMessage: _propTypes.default.string,

  /** Callback invoked to calculate if the row should not be taken into account for selecting.*/
  selectableRowDisabled: _propTypes.default.func
};
var _default = TableAccordion;
exports.default = _default;